<ul class="labels">
    <li class="item" *ngFor="let label of labels" (click)="action(label)"
        [ngClass]="{ 'selectable': isChooseObserved }">
        <core-label [label]="label" [hoverable]="isChooseObserved"></core-label>
    </li>
</ul>
